import CompanyView from '../../components/settings/company'
import BranchView from '../../components/settings/branch'
import PrinterView from '../../components/settings/printer'
import SystemBarnchView from '../../components/settings/system_branch'
export default {
  components: {
    CompanyView,
    BranchView,
    PrinterView,
    SystemBarnchView
  },
  mounted () {
    this.checkUser()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/setting.js